import { LOCALES } from 'i18n/locales';

export const createObservationButtonIntl = {
    [LOCALES.ENGLISH]: {
        'createObservation.noAOIDefined': 'Define an area of interest to start creating an observation there.',
        'createObservation.altText': 'Create new observation'
    },
    [LOCALES.WELSH]: {
        'createObservation.noAOIDefined': 'Diffinio maes o ddiddordeb i ddechrau creu arsylwad yno.',
        'createObservation.altText': 'Creu arsylwadau newydd'
    }
};
